/**
 * @generated SignedSource<<f37a8b2f0744f237f4f24916d3ad0883>>
 * @relayHash d3077504ad82143398de67f698bd83fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 68f6ab024dc28ed12433e812725c366f33bf80bbdfc1a50890e0e754e5f9805d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type usePublishWriteWatchDialogQuery$variables = {
  contentId: string;
};
export type usePublishWriteWatchDialogQuery$data = {
  readonly singleContent: {
    readonly currentUserHasAncestorWatchingChildren: boolean | null | undefined;
    readonly currentUserIsWatching: boolean;
    readonly currentUserIsWatchingChildren: boolean | null | undefined;
    readonly id: string | null | undefined;
    readonly space: {
      readonly currentUser: {
        readonly isWatched: boolean;
        readonly isWatchingBlogs: boolean;
      };
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type usePublishWriteWatchDialogQuery = {
  response: usePublishWriteWatchDialogQuery$data;
  variables: usePublishWriteWatchDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "currentUserIsWatching"
      },
      {
        "kind": "ScalarField",
        "name": "currentUserIsWatchingChildren"
      },
      {
        "kind": "ScalarField",
        "name": "currentUserHasAncestorWatchingChildren"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isWatched"
              },
              {
                "kind": "ScalarField",
                "name": "isWatchingBlogs"
              }
            ]
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePublishWriteWatchDialogQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePublishWriteWatchDialogQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d3077504ad82143398de67f698bd83fa",
    "id": "68f6ab024dc28ed12433e812725c366f33bf80bbdfc1a50890e0e754e5f9805d",
    "metadata": {},
    "name": "usePublishWriteWatchDialogQuery",
    "operationKind": "query",
    "text": "query usePublishWriteWatchDialogQuery($contentId:ID!){singleContent(id:$contentId){id,currentUserIsWatching,currentUserIsWatchingChildren,currentUserHasAncestorWatchingChildren,type,space{id,key,currentUser{isWatched,isWatchingBlogs},operations{operation,targetType}}}}"
  }
};
})();

(node as any).hash = "97cf54f4c7a6eb0b9fc152d743a5b208";

export default node;
